import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetAllUser, GetInfoOneUser, PaginationUser, getUserFilter, DelUser} from '../../actions/index';
import PaginationComponent from '../pagination';

class Users extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state = {
            activePage: 1
        }
        this.renderTable = this.renderTable.bind(this);
        this.editUser = this.editUser.bind(this);
        this.delUserOpenModal = this.delUserOpenModal.bind(this);
        this.delUser = this.delUser.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.filterInput = this.filterInput.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetAllUser(token);
    }
    delUserOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelUser').modal('show');
        $('#DelUser').on('shown.bs.modal', function () {
            that.props.GetInfoOneUser(id, token);
        });
    }
    delUser(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelUser(token, this.props.user.user_edit.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                $('input[name="search"]').val('');
                this.props.GetAllUser(token);
            }
        });
    }
    closeModal(){
        $('#DelUser').modal('hide');
        this.props.user.user_edit = {};
    }
    editUser(id, item){
        this.context.router.push('/users/edit/'+id);
    }
    handlePageChange(data){
        let token = localStorage.getItem('id_token_admin');
        this.setState({activePage: data});
        this.props.PaginationUser(token, data);
    };
    filterInput(e){
        let token = localStorage.getItem('id_token_admin');
        this.props.getUserFilter(token, e.target.value);
    }
    renderTable(){
        return this.props.user.user_all.results.map((item, i)=>{
            return(
                <div key={item.id} className="white-block common-list clearfix">
                    <p>{item.id}</p>
                    <p><span className="link-span" onClick={this.editUser.bind(this, item.id)}>{item.first_name} {item.last_name}</span></p>
                    <p>{item.email}</p>
                    <p style={{'height': '20px'}}>{item.coupon_code ? item.coupon_code : ' '}</p>
                    <p>
                        <button type="button" onClick={this.editUser.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delUserOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <p className="dashboard-title">Users</p>
                <p className="dashboard-text">User</p>
                <div>
                    <div className="col-md-12">
                        <div className="white-block">
                            <div className="col-md-4 input-group search_block">
                                <span className="input-group-addon glyphicon glyphicon-search" />
                                <input type="text" name="search" className="form-control" placeholder="Search" aria-describedby="Search" onChange={this.filterInput}/>
                            </div>
                        </div>
                    </div>
                    {this.props.user.user_all.results && this.props.user.user_all.results.length > 0 ?
                        <div>
                            <div className="col-md-12">
                                <div className="common-list clearfix">
                                    <p>#</p>
                                    <p>Name</p>
                                    <p>Email</p>
                                    <p>Coupon</p>
                                    <p>Option</p>
                                </div>
                            </div>
                            <div className="col-md-12">
                                {this.renderTable()}
                            </div>
                            {this.props.user.user_all ?
                                <PaginationComponent
                                    data={this.props.user.user_all}
                                    activePage={this.state.activePage}
                                    handlePageChange = {this.handlePageChange}
                                />
                                :""
                            }
                        </div>
                        :
                        <div className={this.props.user.user_all.results && this.props.user.user_all.results.length < 0 || $.isEmptyObject(this.props.user.user_all) ? "for_preloader" : 'for_preloader dn'}>
                            <div className="preloader-wrapper big active">
                                <div className="spinner-layer spinner-blue-only">
                                    <div className="circle-clipper left">
                                        <div className="circle" />
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle" />
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.user.user_all.results && this.props.user.user_all.results.length === 0 && <p className="noResults">No items result</p>}
                    <div className="modal fade" id="DelUser" tabIndex="-1" role="dialog" aria-labelledby="DelUserLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelUser"></span>
                                    <p>Do you really want to delete user {this.props.user.user_edit ? <span>{this.props.user.user_edit.first_name} {this.props.user.user_edit.last_name}</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delUser} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>

            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        user: state.user
    }
}
export default connect(mapStateToProps, {GetAllUser, GetInfoOneUser, PaginationUser, getUserFilter, DelUser})(Users);


// WEBPACK FOOTER //
// ./src/components/user/users.js